import { sendRentalAgreementEmail } from 'helpers/API Calls/Operations/booking';
import React from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectRentalAgreementSignature } from 'slices/booking/bookingSlice';

function RentalAgreement() {
  const {id} = useParams<{id: string}>();
  const rental_agreement_signature = useSelector(selectRentalAgreementSignature);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [emailSent, setEmailSent] = React.useState<boolean>(false);

  const sendEmail = async () => {
    setLoading(true);
    const response = await sendRentalAgreementEmail({
      booking_id: id,
    })
    if(response.success) {
      setEmailSent(true);
    }
    setLoading(false);
  }

  return (
    <div>
      {rental_agreement_signature ? 
      <img
        src={rental_agreement_signature || null}
        alt="Rental Agreement Signature"
        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
      />
      :
      <>
      <div className='d-flex flex-column align-items-center justify-content-center'>
      <p>No rental agreement signature provided.</p>
        <button className='btn btn-primary mt-2'
          onClick={sendEmail}
          disabled={loading || emailSent}
        >
          {loading ? "Sending Email...": 'Send Rental Agreement Email'}
        </button>
      </div>
      </>
    }
    </div>
  )
}

export default RentalAgreement
